import React from 'react';
import { motion } from 'framer-motion';
import "./workflows.scss";
import ScheduleButton from '../main-banner/ScheduleButton';

const Workflows = () => {
  return (
    <section className='work_main'>
      {/* Background Shade Image */}
      <motion.img
        src='/assets/shade.png'
        className='imggshade'
        initial={{ opacity: 0, scale: 0.95 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1 }}
        viewport={{ once: false }}
        alt='background shade'
      />

      {/* Background Video */}
      <motion.video
        className='main-banner-video'
        muted
        playsInline
        autoPlay
        loop
        width="100%"
        id="myVideo"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 1.2 }}
        viewport={{ once: false }}
      >
        <source src="/assets/bottomvideo.mp4" type="video/mp4" />
      </motion.video>

      <div className='custom-container1'>
        <motion.div
          className='inner_work'
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: false }}
        >
          <h2>Schedule a free IT & automation health check</h2>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.6 }}
            viewport={{ once: false }}
          >
            Let’s talk about how we can secure and streamline your operations.
          </motion.p>

          <motion.div
            className='buttons_div'
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4, duration: 0.6 }}
            viewport={{ once: false }}
          >
            <ScheduleButton />
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default Workflows;
